export const PHISHING = {
  SIMULATIONS: {
    TITLE: 'Phishing Campaigns',
    SIMULATIONS_SECTION: 'Campaigns',
    RECENT_SIMULATIONS: 'Recent campaigns',
    NO_CAMPAIGNS: 'No campaigns yet',
    COLUMNS: {
      TARGETED: 'Targeted',
      SENT: 'Sent',
      VIEWED: 'Viewed',
      CLICKED: 'Clicked',
      CREDENTIALS: 'Credentials',
      REPORTED: 'Reported',
    },
    ICONS: {
      TARGETED_USERS: 'Targeted users',
      EMAILS_VIEWED_VS_DELIVERED: 'Emails viewed/delivered',
      DATE: 'Date',
      CREDENTIALS_ENTERED: 'Credentials entered',
    },
  },
  KPIS: {
    CAMPAIGNS_SENT: 'Campaigns sent',
    EMPLOYEES_TARGETED: 'employees targeted',
    LINKS_CLICKED: 'Links clicked',
    LINKS_CLICKED_NOTE: 'Across all campaigns',
    CREDENTIALS_ENTERED: 'Credentials entered',
    CREDENTIALS_ENTERED_NOTE: 'Employees who submitted their credentials',
    REPORTED: 'Reported',
    REPORTED_NOTE: 'Employees who flagged the email',
  },
  RISK: {
    TITLE: 'Risk profile',
    DESCRIPTION: 'Human exposure to phishing.',
    SCORE_MAX: '/ 100',
    RISK_LOW: 'Low',
    RISK_MODERATE: 'Moderate',
    RISK_HIGH: 'High',
    RISK_EXPLANATION: 'Average of all employee phishing risk scores, on a 0–100 scale',
    OUTCOMES_TITLE: 'Employee outcomes',
    TESTED: 'tested',
    ENTERED_CREDENTIALS: 'Entered credentials',
    REPEAT_CLICKERS: 'Repeat clickers',
    REPORTED_AT_LEAST_ONCE: 'Reported at least once',
    NO_RESULTS: 'No employee results yet',
  },
  TRENDS: {
    TITLE: 'Exercise evolution',
    DESCRIPTION: 'As a share of employees targeted.',
    LINKS_CLICKED: 'Links Clicked',
    CREDENTIALS_ENTERED: 'Credentials Entered',
    VIEWED: 'Emails Viewed',
    REPORTED: 'Reported',
    EMPTY: 'No campaigns yet',
  },
  SIMULATION_DETAIL: {
    BREADCRUMB: {
      PEOPLE: 'Employees',
      PHISHING_SIMULATIONS: 'Phishing Campaigns',
    },
    METRICS: {
      EMAIL_ENGAGEMENT: 'Email engagement',
      CAMPAIGN_REACH: 'Campaign reach & interaction',
      EMPLOYEES_TARGETED: 'Employees targeted',
      EMAILS_VIEWED_DELIVERED: 'Emails viewed/delivered',
      REPLIES: 'Replies',
      SECURITY_RESPONSE: 'Security response',
      USER_BEHAVIOR: 'User behavior and security awareness',
      LINKS_CLICKED: 'Links clicked',
      CREDENTIALS_ENTERED: 'Credentials Entered',
      REPORTED: 'Reported',
    },
    EMPLOYEE_RESULTS: {
      TITLE: 'Employee Results',
      SEARCH_PLACEHOLDER: 'Search employees...',
      TABLE: {
        EMAIL: 'Email',
        DELIVERY_STATUS: 'Delivery Status',
        VIEWED: 'Viewed',
        REPLIED: 'Replied',
        CLICKED: 'Clicked',
        CREDENTIALS: 'Credentials',
        REPORTED: 'Reported',
      },
      STATUS: {
        DELIVERED: 'Delivered',
        BOUNCED: 'Bounced',
        PENDING: 'Pending',
        UNKNOWN: 'Unknown',
      },
      FILTERS: {
        ALL: 'All',
        VIEWED: 'Viewed',
        REPLIED: 'Replied',
        CLICKED: 'Clicked',
        CREDENTIALS: 'Credentials',
        REPORTED: 'Reported',
      },
    },
    TEMPLATE_VIEWER: {
      TITLE: 'Campaign templates',
      EMAIL_TEMPLATE: 'See email template',
      LANDING_PAGE: 'See landing page',
      EMAIL_TEMPLATE_TITLE: 'Email Template',
      LANDING_PAGE_TITLE: 'Landing Page',
      EMAIL_TEMPLATE_ALT: 'Email template',
      LANDING_PAGE_ALT: 'Landing page',
    },
  },
}
